import { z } from 'zod'
import { HEADER_KEYS } from '@reward-platform/shared-schemas'
import { ValidationError } from '~/utils/errors'
import { ApiRequestParams } from './types'

export const createServiceSchemaValidator =
  <T extends z.AnyZodObject | z.ZodOptional<z.AnyZodObject> | z.ZodArray<z.AnyZodObject>>(
    schema: T
  ) =>
  (data: unknown, message?: string): z.infer<T> => {
    const safeParse = schema.safeParse(data)
    if (!safeParse.success) {
      const error = new ValidationError(safeParse.error, message)
      error.logToDatadog()
      throw error
    }
    return safeParse.data
  }

export const getDefaultApiClientOptions = (params: ApiRequestParams) => {
  const { opCo, countryCode, currencyCode, locale } = params

  return {
    headers: {
      [HEADER_KEYS.countryCode]: countryCode,
      [HEADER_KEYS.currencyCode]: currencyCode,
      [HEADER_KEYS.partnerCode]: opCo,
      [HEADER_KEYS.languageCode]: locale,
    },
  }
}
